module.exports = __webpack_public_path__ + "img/header.5dded618.png";